import { render, staticRenderFns } from "./PageCompatible.vue?vue&type=template&id=f9f7d4d4&"
import script from "./PageCompatible.vue?vue&type=script&lang=js&"
export * from "./PageCompatible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/bluehost-site-migrator/bluehost-site-migrator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9f7d4d4')) {
      api.createRecord('f9f7d4d4', component.options)
    } else {
      api.reload('f9f7d4d4', component.options)
    }
    module.hot.accept("./PageCompatible.vue?vue&type=template&id=f9f7d4d4&", function () {
      api.rerender('f9f7d4d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "source/components/PageCompatible.vue"
export default component.exports